// 操作审计记录信息
const AuditTemplate = {
  login:{
    OperationDesc: '登录'
  },

  logout:{
    OperationDesc: '登出'
  },

  refresh_tree: {
    OperationDesc: '刷新IT资源树'
  },

  add_group: {
    OperationDesc: '添加分组: ',
    isAfter: true
  },

  edit_group: {
    OperationDesc: '编辑分组: ',
    isAfter: true
  },

  delete_group: {
    OperationDesc: '删除分组: ',
    isAfter: true
  },

  enable_group: {
    OperationDesc: '启用分组: ',
    isAfter: true
  },

  disable_group: {
    OperationDesc: '禁用分组: ',
    isAfter: true
  },

  sort_group: {
    OperationDesc: '分组排序: ',
    isAfter: true
  },

  sort_resource: {
    OperationDesc: '资源排序: ',
    isAfter: true
  },

  add_resource: {
    OperationDesc: '添加资源: ',
    isAfter: true
  },

  edit_resource: {
    OperationDesc: '编辑资源: ',
    isAfter: true
  },

  delete_resource: {
    OperationDesc: '删除资源: ',
    isAfter: true
  },

  enable_resource: {
    OperationDesc: '启用资源: ',
    isAfter: true
  },

  disable_resource: {
    OperationDesc: '禁用资源: ',
    isAfter: true
  },

  refresh_resource: {
    OperationDesc: '刷新资源: ',
    isAfter: true
  },

  test_resource: {
    OperationDesc: '测试连接资源: ',
    isAfter: true
  },

  add_monitor: {
    OperationDesc: '添加监测器: ',
    isAfter: true
  },

  edit_monitor: {
    OperationDesc: '编辑监测器: ',
    isAfter: true
  },

  delete_monitor: {
    OperationDesc: '删除监测器: ',
    isAfter: true
  },

  enable_monitor: {
    OperationDesc: '启用监测器: ',
    isAfter: true
  },

  disable_monitor: {
    OperationDesc: '禁用监测器: ',
    isAfter: true
  },

  refresh_monitor: {
    OperationDesc: '刷新监测器: ',
    isAfter: true
  },

  batchRefresh_monitor: {
    OperationDesc: '批量刷新监测器: ',
    isAfter: true
  },

  batchDelete_monitor: {
    OperationDesc: '批量删除监测器: ',
    isAfter: true
  },

  batchEnable_monitor: {
    OperationDesc: '批量启用监测器: ',
    isAfter: true
  },

  batchDisable_monitor: {
    OperationDesc: '批量禁用监测器: ',
    isAfter: true
  },

  edit_threshold: {
    OperationDesc: '编辑阀值: ',
    isAfter: true
  },

  query_monitor_group: {
    OperationDesc: '查询组下监测器: ',
    isAfter: true
  },

  query_monitor_list: {
    OperationDesc: '查询监测器列表: ',
    isAfter: true
  },

  query_monitor: {
    OperationDesc: '查询监测器: ',
    isAfter: true
  },

  query_monitor_trend: {
    OperationDesc: '查询监测器趋势报表: ',
    isAfter: true
  },

  query_monitor_state: {
    OperationDesc: '查询监测器状态报表: ',
    isAfter: true
  },

  query_monitor_log: {
    OperationDesc: '查询监测器日志: ',
    isAfter: true
  },

  query_alarm_event: {
    OperationDesc: '查询报警事件: ',
    isAfter: true
  },

  continue_alarm_event: {
    OperationDesc: '继续告警: ',
    isAfter: true
  },

  pause_alarm_event: {
    OperationDesc: '暂停告警: ',
    isAfter: true
  },

  add_alarm_rule: {
    OperationDesc: '添加报警规则: ',
    isAfter: true
  },

  edit_alarm_rule: {
    OperationDesc: '编辑报警规则: ',
    isAfter: true
  },

  delete_alarm_rule: {
    OperationDesc: '删除报警规则: ',
    isAfter: true
  },

  batchDelete_alarm_rule: {
    OperationDesc: '批量删除报警规则: ',
    isAfter: true
  },

  refresh_alarm_rule: {
    OperationDesc: '刷新报警规则列表'
  },

  start_alarm_rule: {
    OperationDesc: '启动报警规则: ',
    isAfter: true
  },

  stop_alarm_rule: {
    OperationDesc: '禁止报警规则: ',
    isAfter: true
  },

  batchStart_alarm_rule: {
    OperationDesc: '批量启动报警规则: ',
    isAfter: true
  },

  batchStop_alarm_rule: {
    OperationDesc: '批量禁止报警规则: ',
    isAfter: true
  },

  query_alarm_rule_event: {
    OperationDesc: '查询报警规则事件: ',
    isAfter: true
  },

  test_send_wechat: {
    OperationDesc: '测试发送微信: ',
    isAfter: true
  },

  test_send_email: {
    OperationDesc: '测试发送邮件: ',
    isAfter: true
  },

  test_send_sms: {
    OperationDesc: '测试发送短信',
  },

  setting_email_server: {
    OperationDesc: '设置邮件服务器: ',
    isAfter: true
  },

  query_email_setting: {
    OperationDesc: '重新获取邮件服务器设置'
  },

  add_email_template: {
    OperationDesc: '添加邮箱模板: ',
    isAfter: true
  },

  edit_email_template: {
    OperationDesc: '编辑邮箱模板: ',
    isAfter: true
  },

  delete_email_template: {
    OperationDesc: '删除邮箱模板: ',
    isAfter: true
  },

  batchDelete_email_template: {
    OperationDesc: '批量删除邮箱模板: ',
    isAfter: true
  },

  setting_sms_server: {
    OperationDesc: '设置短信猫: ',
    isAfter: true
  },

  start_sms_server: {
    OperationDesc: '开启短信服务',
  },

  query_sms_setting: {
    OperationDesc: '重新获取短信猫设置'
  },

  add_sms_template: {
    OperationDesc: '添加短信模板: ',
    isAfter: true
  },

  edit_sms_template: {
    OperationDesc: '编辑短信模板: ',
    isAfter: true
  },

  delete_sms_template: {
    OperationDesc: '删除短信模板: ',
    isAfter: true
  },

  batchDelete_sms_template: {
    OperationDesc: '批量删除短信模板: ',
    isAfter: true
  },

  query_alarm_log: {
    OperationDesc: '查询发送日志: ',
    isAfter: true
  },

  start_private_user: {
    OperationDesc: '开启私有用户: ',
    isAfter: true
  },

  stop_private_user: {
    OperationDesc: '停止私有用户: ',
    isAfter: true
  },

  refresh_report_tree: {
    OperationDesc: '刷新监测树',
  },

  query_trend_report: {
    OperationDesc: '查询趋势报表: ',
    isAfter: true
  },

  query_state_report: {
    OperationDesc: '查询状态统计报表: ',
    isAfter: true
  },

  query_compare_report: {
    OperationDesc: '查询对比报表: ',
    isAfter: true
  },

  add_topN_report: {
    OperationDesc: '添加TopN报表: ',
    isAfter: true
  },

  edit_topN_report: {
    OperationDesc: '编辑TopN报表: ',
    isAfter: true
  },

  delete_topN_report: {
    OperationDesc: '删除TopN报表: ',
    isAfter: true
  },

  refresh_topN_report: {
    OperationDesc: '刷新TopN报表'
  },

  start_topN_report: {
    OperationDesc: '允许TopN报表: ',
    isAfter: true
  },

  stop_topN_report: {
    OperationDesc: '禁止TopN报表: ',
    isAfter: true
  },

  batchDelete_topN_report: {
    OperationDesc: '批量删除TopN报表: ',
    isAfter: true
  },

  batchStart_topN_report: {
    OperationDesc: '批量允许TopN报表: ',
    isAfter: true
  },

  batchStop_topN_report: {
    OperationDesc: '批量禁止TopN报表: ',
    isAfter: true
  },

  manual_topN_report: {
    OperationDesc: '手动生成TopN报表: ',
    isAfter: true
  },

  export_topN_report: {
    OperationDesc: '导出TopN报表: ',
    isAfter: true
  },

  delete_topN_report_file: {
    OperationDesc: '删除TopN报表文件: ',
    isAfter: true
  },

  batchDelete_topN_report_file: {
    OperationDesc: '批量删除TopN报表文件: ',
    isAfter: true
  },

  query_topN_report_file: {
    OperationDesc: '查询TopN报表对应文件信息: ',
    isAfter: true
  },

  query_check_log_report: {
    OperationDesc: '查询巡检日志: ',
    isAfter: true
  },

  edit_change_password: {
    OperationDesc: '修改密码',
  },

  add_user: {
    OperationDesc: '添加用户: ',
    isAfter: true
  },

  edit_user: {
    OperationDesc: '编辑用户: ',
    isAfter: true
  },

  delete_user: {
    OperationDesc: '删除用户: ',
    isAfter: true
  },

  batchDelete_user: {
    OperationDesc: '批量删除用户: ',
    isAfter: true
  },

  edit_reset_password: {
    OperationDesc: '重置密码: ',
    isAfter: true
  },

  refresh_user_list: {
    OperationDesc: '刷新用户列表',
  },

  import_user: {
    OperationDesc: '导入用户: ',
    isAfter: true
  },

  add_role: {
    OperationDesc: '添加角色: ',
    isAfter: true
  },

  edit_role: {
    OperationDesc: '编辑角色: ',
    isAfter: true
  },

  delete_role: {
    OperationDesc: '删除角色: ',
    isAfter: true
  },

  batchDelete_role: {
    OperationDesc: '批量删除角色: ',
    isAfter: true
  },

  refresh_role_list: {
    OperationDesc: '刷新角色列表',
  },

  edit_permission: {
    OperationDesc: '编辑权限: ',
    isAfter: true
  },

  add_role_user: {
    OperationDesc: '添加角色对应用户: ',
    isAfter: true
  },

  query_role_user_list: {
    OperationDesc: '查询角色对应用户列表: ',
    isAfter: true
  },

  add_organization: {
    OperationDesc: '新增组织: ',
    isAfter: true
  },

  edit_organization: {
    OperationDesc: '编辑组织: ',
    isAfter: true
  },

  delete_organization: {
    OperationDesc: '删除组织: ',
    isAfter: true
  },

  batchSetting_monitor: {
    OperationDesc: '批量设置监测器: ',
    isAfter: true
  },

  batchSetting_resource: {
    OperationDesc: '批量设置资源: ',
    isAfter: true
  },

  add_taskplan: {
    OperationDesc: '添加任务计划: ',
    isAfter: true
  },

  edit_taskplan: {
    OperationDesc: '编辑任务计划: ',
    isAfter: true
  },

  delete_taskplan: {
    OperationDesc: '删除任务计划: ',
    isAfter: true
  },

  batchDelete_taskplan: {
    OperationDesc: '批量删除任务计划: ',
    isAfter: true
  },

  refresh_taskplan: {
    OperationDesc: '刷新任务计划列表',
  },

  refresh_database_config: {
    OperationDesc: '刷新数据源配置',
  },

  add_database_config: {
    OperationDesc: '添加数据源: ',
    isAfter: true
  },

  edit_database_config: {
    OperationDesc: '编辑数据源: ',
    isAfter: true
  },

  delete_database_config: {
    OperationDesc: '删除数据源: ',
    isAfter: true
  },

  test_database_config: {
    OperationDesc: '测试连接数据库: ',
    isAfter: true
  },

  sort_database_config: {
    OperationDesc: '数据源排序',
  },

  update_database: {
    OperationDesc: '更新数据库: ',
    isAfter: true
  },

  backup_database: {
    OperationDesc: '备份数据库: ',
    isAfter: true
  },

  setting_sync_database: {
    OperationDesc: '是否同步日志到数据库',
    isAfter: true
  },

  delete_es_database: {
    OperationDesc: 'ElasticSearch数据清理',
  },

  setting_database_timing: {
    OperationDesc: '设置定时自动删除ElasticSearch数据: ',
    isAfter: true
  },

  setting_database_activity: {
    OperationDesc: '设置活动中的日志数据: ',
    isAfter: true
  },

  setting_background: {
    OperationDesc: '保存调度控制后台配置: ',
    isAfter: true
  },

  start_servive_control: {
    OperationDesc: '开启服务: ',
    isAfter: true
  },

  stop_servive_control: {
    OperationDesc: '停止服务: ',
    isAfter: true
  },

  refresh_system_detect: {
    OperationDesc: '刷新系统自检情况',
  },

  query_system_detect: {
    OperationDesc: '查询系统自检: ',
    isAfter: true
  },

  query_operation_audit: {
    OperationDesc: '查询操作审计: ',
    isAfter: true
  },

  add_resource_image: {
    OperationDesc: '添加资源图标: ',
    isAfter: true
  },

  edit_resource_image: {
    OperationDesc: '编辑资源图标: ',
    isAfter: true
  },

  delete_resource_image: {
    OperationDesc: '删除资源图标: ',
    isAfter: true
  },

  batchDelete_resource_image: {
    OperationDesc: '批量删除资源图标: ',
    isAfter: true
  },

  refresh_resource_image: {
    OperationDesc: '刷新资源图标列表',
  },

  edit_3D_network_node: {
    OperationDesc: '编辑节点位置',
  },

  query_all_equipment: {
    OperationDesc: '查询所有资源及其监测器',
    isAfter: true
  },

  add_equipment_info_maintenance: {
    OperationDesc: '添加设备维护信息: ',
    isAfter: true
  },

  update_equipment_info_maintenance: {
    OperationDesc: '更新设备维护信息: ',
    isAfter: true
  },

  delete_equipment_info_maintenance:{
    OperationDesc: '删除设备维护信息: ',
    isAfter: true
  }

}

// 操作类型
export const OperationTypes = [
  { key: 'login', name: '登录' },
  { key: 'logout', name: '登出' },
  { key: 'add', name: '添加' },
  { key: 'edit', name: '编辑/修改' },
  { key: 'delete', name: '删除' },
  { key: 'enable', name: '启用' },
  { key: 'disable', name: '禁用' },
  { key: 'refresh', name: '刷新' },
  { key: 'sort', name: '排序' },
  { key: 'query', name: '查询' },
  { key: 'batchRefresh', name: '批量刷新' },
  { key: 'batchDelete', name: '批量删除' },
  { key: 'batchEnable', name: '批量启用' },
  { key: 'batchDisable', name: '批量禁用' },
  { key: 'test', name: '测试' },
  { key: 'continue', name: '继续' },
  { key: 'pause', name: '暂停' },
  { key: 'start', name: '启动/允许/开启' },
  { key: 'stop', name: '禁止/停止' },
  { key: 'batchStart', name: '批量启动/允许' },
  { key: 'batchStop', name: '批量禁止' },
  { key: 'manual', name: '生成' },
  { key: 'import', name: '导入' },
  { key: 'export', name: '导出' },
  { key: 'update', name: '更新' },
  { key: 'backup', name: '备份' },
  { key: 'setting', name: '设置' },
  { key: 'batchSetting', name: '批量设置' },
  { key: 'other', name: '其他' },
];

// 操作对象
export const OperationObjects = {
  user: '用户',
  group: '组',
  resource: '资源',
  monitor: '监测器',
  topu: '立体拓扑',
  alarm: '告警',
  report: '报表',
  database: '数据库',
  setting: '系统设置',
};

export function getAuditTemplate(param) {
  const _type = param.type ? param.type.split('_')[0] : '';
  let template = AuditTemplate[param.type];
  const operationBo = param.BoId ? OperationObjects[param.BoId] : '';
  let operationDesc = template.OperationDesc || '';
  if (template.isAfter && param.hasOwnProperty('desc')) {
    operationDesc += param.desc;
    delete param.desc;
  }
  // topN报表，巡检错误报表，巡检统计报表共用一组描述
  if (param.hasOwnProperty('reportType')) {
    if (param.reportType) {
      operationDesc = operationDesc.replace('TopN', param.reportType)
    }
    delete param.reportType;
  }
  return {
    OperationType: _type,
    OperationBo: operationBo,
    OperationDesc: operationDesc,
    OperationAssociation: template.OperationAssociation || ''
  }
};
